import React from 'react';
import ArticleHeader from '../../platformui/ArticleHeader';
import Breadcrumb from '../../platformui/Breadcrumb';
import * as Render from '../../platformui/Base/Render';
import Localnav from '../../platformui/Localnav';
import Share from '../../platformui/Share';
import ArticleFooter from '../../platformui/ArticleFooter';

import ReferenceBlock from '../../blocks/reference-block';
import ChapterBlock from '../../blocks/chapter-block';
import ImageBlock from '../../blocks/image-block';
import VideoBlock from '../../blocks/video-block';
import LinkCollectionBlock from '../../blocks/linklist-block';
import ReferenceListBlock from '../../blocks/referencelist-block';

const Blocks = {
  ReferenceBlock,
  ChapterBlock,
  ImageBlock,
  VideoBlock,
  LinkCollectionBlock,
  ReferenceListBlock,
};

const ReferencePage = (props) => {
  return (
    <main className="main">
      <section className="reference">
        <div className="row">
          <div className="columns">
            <Breadcrumb {...props.Breadcrumbs} />
          </div>
        </div>
        <div id="content" className="row u-article-main">
          <div className="columns medium-offset-2 medium-8 large-6">
            <ArticleHeader
              Heading={Render.Property(props.Content.Heading, 'Heading')}
              HeadingTranslation={props.Content.HeadingTranslation}
              Preamble={Render.Property(props.Content.Preamble, 'Preamble')}
            />

            <h3 className="reference__list-heading">
              {props.Content.ReferenceHeading}
            </h3>

            <div className="u-blocklist">
              <ol className="reference__list">
                <Render.Block
                  blocks={props.Content.References}
                  propertyName="References"
                  currentPageProps={props}
                >
                  <Render.BlockTypeRenderer Blocks={Blocks} />
                </Render.Block>
              </ol>
            </div>

            <div className="u-blocklist">
              <Render.Block
                blocks={props.Content.MainContent}
                propertyName="MainContent"
                currentPageProps={props}
              >
                <Render.BlockTypeRenderer Blocks={Blocks} />
              </Render.Block>
            </div>
            <Share {...props.Content} />
            {props.Content.ArticleFooter && (
              <ArticleFooter
                ArticleFooter={props.Content.ArticleFooter}
                Translations={props.Content.Translations}
                Site={props.Site}
              />
            )}
          </div>
          {props.Content && props.Content.ShowLocalNav && (
            <div className="columns medium-2 large-3 show-for-large u-right-col">
              <Localnav {...props.LocalMenu} />
            </div>
          )}
        </div>
      </section>
    </main>
  );
};

export default ReferencePage;